import { getObjectListByPropertyApi, putUpdateObjectListByPropertyValueArrayApi } from "api/general";
import { getAgendaListByMeetingIdApi } from "api/meeting";
import { sortByProperty } from "app/utils/appHelpers";
import { DECISION, REVIEWS, VOTE } from "app/utils/constants/customConstant";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentAgendaList, setCurrentMeetingReviewList, setCurrentMeetingVoteList } from "stores/meeting";
import AgendaContainer from "../Container/AgendaContainer";

function MeetingAgendaTab() {
    const dispatch = useDispatch();

    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const [loading, setLoading] = useState(true);
    const [agendaList, setAgendaList] = useState([]);
    const userList = useSelector(state => state.user.data || []);
    const currentMeetingReviewList = useSelector(state => state.meeting.currentMeetingReviewList);
    const currentMeetingVoteList = useSelector(state => state.meeting.currentMeetingVoteList);
    const currentAgendaList = useSelector(state => state.meeting.currentAgendaList);
    const currentMeetingUsers = useSelector(state => state.meeting.currentMeetingUsers);
    useEffect(() => {
        const getAPI = async () => {
            if (!currentMeeting?.id) {
                setLoading(false);
                return;
            }

            const needsAgenda = !currentAgendaList?.length;
            const needsReview = currentMeetingReviewList === null;
            const needsVote = currentMeetingVoteList === null;

            if (!needsAgenda && !needsReview && !needsVote) {
                setLoading(false);
                return;
            }

            setLoading(needsAgenda);

            try {
                const userById = new Map((userList || []).map((u) => [u.id, u]));
                const meetingUserByUserId = new Map((currentMeetingUsers || []).map((x) => [x.userId, x]));

                const agendaTask = needsAgenda ? (async () => {
                    const resultMeetingAgendas = await getAgendaListByMeetingIdApi(currentMeeting.id);
                    let data = resultMeetingAgendas.data || [];
                    data.forEach((item) => {
                        item.user = userById.get(item.adminUserId);
                    });
                    data = sortByProperty(data, "decisionNo");
                    setAgendaList(data);
                    dispatch(setCurrentAgendaList([...data]));
                })() : null;

                const reviewTask = needsReview ? (async () => {
                    const resultMeetingReviews = await getObjectListByPropertyApi(REVIEWS, "meetingId", currentMeeting.id);
                    let dataReview = (resultMeetingReviews.data || []).map((item) => {
                        const meetingUser = meetingUserByUserId.get(item.userId);
                        return {
                            ...item,
                            user: userById.get(item.userId),
                            indexNo: meetingUser ? meetingUser.indexNo : Number.MAX_SAFE_INTEGER
                        };
                    });
                    dataReview.sort((a, b) => a.indexNo - b.indexNo);
                    dispatch(setCurrentMeetingReviewList([...dataReview]));
                })() : null;

                const voteTask = needsVote ? (async () => {
                    const resultMeetingVotes = await getObjectListByPropertyApi(VOTE, "meetingId", currentMeeting.id);
                    let dataVotes = resultMeetingVotes.data || [];
                    dataVotes.forEach((item) => {
                        item.user = userById.get(item.userId);
                    });
                    dispatch(setCurrentMeetingVoteList([...dataVotes]));
                })() : null;

                if (agendaTask) {
                    await agendaTask;
                    setLoading(false);
                }

                await Promise.all([reviewTask, voteTask].filter(Boolean));
            } catch (error) {
                setLoading(false);
            } finally {
                setLoading(false);
            }
        };

        getAPI();
    }, [currentMeeting]);

    const sortingAfterData = async (sortedData) => {
        sortedData = sortedData.map((item, idx) => ({
            ...item,
            decisionNo: idx + 1,
        }));
        const objectList = sortedData.map(({ id, decisionNo }) => ({ id, decisionNo }));
        const result = await putUpdateObjectListByPropertyValueArrayApi(DECISION, "decisionNo", objectList);

        if (result.status) {
            setAgendaList([...sortedData]);
            dispatch(setCurrentAgendaList([...sortedData]));
        }
    };



    return (
        <div>
            {
                <AgendaContainer loading={loading} >
                </AgendaContainer>
            }

        </div>
    );
}

export default MeetingAgendaTab;